/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  UpdateUserMutationRequest,
  UpdateUserMutationResponse,
  UpdateUserPathParams,
} from "../types/UpdateUser.ts"
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { mutationOptions, useMutation } from "@tanstack/react-query"

export const updateUserMutationKey = () => [{ url: "/v1/user/:id" }] as const

export type UpdateUserMutationKey = ReturnType<typeof updateUserMutationKey>

/**
 * @summary Update user
 * {@link /v1/user/:id}
 */
export async function updateUser(
  id: UpdateUserPathParams["id"],
  data: UpdateUserMutationRequest,
  config: Partial<RequestConfig<UpdateUserMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    UpdateUserMutationResponse,
    ResponseErrorConfig<Error>,
    UpdateUserMutationRequest
  >({
    method: "PUT",
    url: `/v1/user/${id}`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function updateUserMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<UpdateUserMutationRequest>> & {
    client?: Client
  } = {}
) {
  const mutationKey = updateUserMutationKey()
  return mutationOptions<
    ResponseConfig<UpdateUserMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: UpdateUserPathParams["id"]; data: UpdateUserMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id, data }) => {
      return updateUser(id, data, config)
    },
  })
}

/**
 * @summary Update user
 * {@link /v1/user/:id}
 */
export function useUpdateUser<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<UpdateUserMutationResponse>,
      ResponseErrorConfig<Error>,
      { id: UpdateUserPathParams["id"]; data: UpdateUserMutationRequest },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig<UpdateUserMutationRequest>> & {
      client?: Client
    }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? updateUserMutationKey()

  const baseOptions = updateUserMutationOptions(config) as UseMutationOptions<
    ResponseConfig<UpdateUserMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: UpdateUserPathParams["id"]; data: UpdateUserMutationRequest },
    TContext
  >

  return useMutation<
    ResponseConfig<UpdateUserMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: UpdateUserPathParams["id"]; data: UpdateUserMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<UpdateUserMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: UpdateUserPathParams["id"]; data: UpdateUserMutationRequest },
    TContext
  >
}
